
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("sc949", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ad26e2649dc7338$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $gmMgo = parcelRequire("gmMgo");


var $5MaNT = parcelRequire("5MaNT");


var $9QfXi = parcelRequire("9QfXi");


var $7Rcde = parcelRequire("7Rcde");


var $1oCLl = parcelRequire("1oCLl");


var $kQVmG = parcelRequire("kQVmG");

function $0ad26e2649dc7338$var$CodeBlock(props) {
    const { text: text, language: language, allowCopyToClipboard: allowCopyToClipboard = false, allowWrapCodeBlock: allowWrapCodeBlock = false, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, localId: localId } = props;
    const codeBidiWarningLabel = props.intl.formatMessage((0, $7Rcde.codeBidiWarningMessages).label);
    const className = [
        (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER,
        props.className
    ].join(' ');
    const [wrapLongLines, setWrapLongLines] = (0, $42omo.useState)(false);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $kQVmG.default), {
        allowCopyToClipboard: allowCopyToClipboard,
        allowWrapCodeBlock: allowWrapCodeBlock,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        localId: localId,
        setWrapLongLines: setWrapLongLines,
        text: text,
        wrapLongLines: wrapLongLines
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9QfXi.default), {
        testId: "renderer-code-block",
        language: language,
        text: text,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        shouldWrapLongLines: allowWrapCodeBlock && wrapLongLines,
        hasBidiWarnings: (0, $1oCLl.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true) ? false : undefined
    }));
}
var $0ad26e2649dc7338$export$2e2bcd8739ae039 = (0, $gmMgo.default)($0ad26e2649dc7338$var$CodeBlock);

});

parcelRegister("kQVmG", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $6fnsQ = parcelRequire("6fnsQ");


var $5MaNT = parcelRequire("5MaNT");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $9hz8e = parcelRequire("9hz8e");

const $1577a14320481940$var$codeBlockStyleOverrides = /*#__PURE__*/ (0, $9K4OG.css)({
    tabSize: 4,
    backgroundColor: `var(--ds-surface-raised, ${(0, $6fnsQ.N20)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    button: {
        opacity: 0,
        transition: 'opacity 0.2s ease 0s'
    },
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        button: {
            opacity: 1
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`${(0, $5MaNT.CodeBlockSharedCssClassName).DS_CODEBLOCK}`]: {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '1.5rem',
        backgroundImage: `linear-gradient(
			to right,
			${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-300, 24px)"},
			transparent ${"var(--ds-space-300, 24px)"}
			),linear-gradient(
			to right,
			${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
			transparent ${"var(--ds-space-300, 24px)"}
			),linear-gradient(
			to left,
			${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-100, 8px)"},
			transparent ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to left,
			${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
			transparent ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to left,
			${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			),linear-gradient(
			to right,
			${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
			${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
			)`,
        backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
        backgroundPosition: '0 0, 0 0, 100% 0, 100% 0, 100% 0, 100% 0, 0 0, 0 0'
    }
});
const $1577a14320481940$var$denseModeOverrides = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`${(0, $5MaNT.CodeBlockSharedCssClassName).DS_CODEBLOCK}`]: {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '1.5em'
    }
});
const $1577a14320481940$var$CodeBlockContainer = ({ allowCopyToClipboard: allowCopyToClipboard, allowWrapCodeBlock: allowWrapCodeBlock, children: children, className: className, localId: localId, setWrapLongLines: setWrapLongLines, text: text, wrapLongLines: wrapLongLines })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-local-id": localId,
        css: [
            $1577a14320481940$var$codeBlockStyleOverrides,
            ((0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp')) && $1577a14320481940$var$denseModeOverrides
        ]
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9hz8e.default), {
        allowCopyToClipboard: allowCopyToClipboard,
        allowWrapCodeBlock: allowWrapCodeBlock,
        setWrapLongLines: setWrapLongLines,
        text: text,
        wrapLongLines: wrapLongLines
    }), children);
};
var $1577a14320481940$export$2e2bcd8739ae039 = $1577a14320481940$var$CodeBlockContainer;
module.exports["default"] = $1577a14320481940$export$2e2bcd8739ae039;

});

parcelRegister("9hz8e", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $fHPm9 = parcelRequire("fHPm9");


var $bv6rO = parcelRequire("bv6rO");


var $6fnsQ = parcelRequire("6fnsQ");

const $a870006f5338ad0e$var$codeBlockButtonsWrapper = /*#__PURE__*/ (0, $9K4OG.css)({
    position: 'sticky',
    top: '0px',
    background: `${`var(--ds-surface, ${(0, $6fnsQ.N20)})`}`
});
const $a870006f5338ad0e$var$codeBlockButtonsStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'absolute',
    height: '0',
    width: '100%',
    right: "var(--ds-space-075, 6px)",
    top: "var(--ds-space-050, 4px)",
    padding: "var(--ds-space-025, 2px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    button: {
        height: '32px',
        width: '32px',
        border: `${"var(--ds-border-width-selected, 2px)"} solid ${`var(--ds-border, ${(0, $6fnsQ.N0)})`}`,
        borderRadius: "var(--ds-radius-small, 4px)",
        marginLeft: "var(--ds-space-050, 4px)",
        padding: "var(--ds-space-025, 2px)",
        background: `${`var(--ds-surface-overlay, ${(0, $6fnsQ.N20)})`}`,
        color: `${"var(--ds-icon, rgb(66, 82, 110))"}`,
        '&:hover': {
            borderWidth: "var(--ds-border-width-selected, 2px)",
            backgroundColor: `${`var(--ds-surface-overlay-hovered, ${(0, $6fnsQ.N30)})`}`,
            height: '32px',
            width: '32px'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.clicked': {
            backgroundColor: `${`var(--ds-background-neutral-bold-pressed, ${(0, $6fnsQ.N700)})`}`,
            borderRadius: "var(--ds-radius-small, 4px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            color: `${`var(--ds-icon-inverse, ${(0, $6fnsQ.N0)})`} !important`
        }
    }
});
const $a870006f5338ad0e$var$CodeBlockButtonContainer = ({ allowCopyToClipboard: allowCopyToClipboard, allowWrapCodeBlock: allowWrapCodeBlock, setWrapLongLines: setWrapLongLines, text: text, wrapLongLines: wrapLongLines })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $a870006f5338ad0e$var$codeBlockButtonsWrapper
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $a870006f5338ad0e$var$codeBlockButtonsStyle
    }, allowWrapCodeBlock && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bv6rO.default), {
        setWrapLongLines: setWrapLongLines,
        wrapLongLines: wrapLongLines
    }), allowCopyToClipboard && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $fHPm9.default), {
        content: text
    })));
};
var $a870006f5338ad0e$export$2e2bcd8739ae039 = $a870006f5338ad0e$var$CodeBlockButtonContainer;
module.exports["default"] = $a870006f5338ad0e$export$2e2bcd8739ae039;

});

parcelRegister("fHPm9", function(module, exports) {
$parcel$export(module.exports, "default", () => $890d768eb03ab16f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4KS7f = parcelRequire("4KS7f");


var $f8J4a = parcelRequire("f8J4a");


var $gt9HV = parcelRequire("gt9HV");


var $3gadb = parcelRequire("3gadb");


var $9K4OG = parcelRequire("9K4OG");


var $42omo = parcelRequire("42omo");


var $gmMgo = parcelRequire("gmMgo");


var $6uN0A = parcelRequire("6uN0A");


var $gi5bC = parcelRequire("gi5bC");


var $kIphX = parcelRequire("kIphX");

const $890d768eb03ab16f$var$CopyButton = ({ content: content, intl: intl })=>{
    const [tooltip, setTooltip] = (0, $42omo.useState)(intl.formatMessage((0, $f8J4a.codeBlockButtonMessages).copyCodeToClipboard));
    const [className, setClassName] = (0, $42omo.useState)('copy-to-clipboard');
    const onMouseLeave = ()=>{
        setTooltip(intl.formatMessage((0, $f8J4a.codeBlockButtonMessages).copyCodeToClipboard));
        setClassName('copy-to-clipboard');
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6uN0A.default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
            content: tooltip,
            hideTooltipOnClick: false,
            position: "top"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            onMouseLeave: onMouseLeave
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4KS7f.default), {
            appearance: "subtle",
            "aria-haspopup": true,
            "aria-label": tooltip,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            iconBefore: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gt9HV))), {
                label: tooltip
            }),
            onClick: (event)=>{
                fireAnalyticsEvent({
                    // @ts-expect-error - Type 'ACTION.CLICKED' is not assignable to type 'ACTION.CLICKED | ACTION.MEDIA_LINK_TRANSFORMED | ACTION.STARTED | ACTION.TOGGLE_EXPAND | ACTION.UNSUPPORTED_CONTENT_ENCOUNTERED | ACTION.VISITED | ACTION.RENDERED | ACTION.INVALID_PROSEMIRROR_DOCUMENT | ACTION.CRASHED | ... 6 more ... | AnnotationActionType'.
                    // This error was introduced after upgrading to TypeScript 5
                    action: (0, $gi5bC.ACTION).CLICKED,
                    actionSubject: (0, $gi5bC.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $gi5bC.ACTION_SUBJECT_ID).CODEBLOCK_COPY,
                    eventType: (0, $gi5bC.EVENT_TYPE).UI
                });
                (0, $kIphX.copyTextToClipboard)(content);
                setTooltip(intl.formatMessage((0, $f8J4a.codeBlockButtonMessages).copiedCodeToClipboard));
                setClassName('copy-to-clipboard clicked');
                event.stopPropagation();
            },
            spacing: "compact"
        })))));
};
var $890d768eb03ab16f$export$2e2bcd8739ae039 = (0, $gmMgo.default)($890d768eb03ab16f$var$CopyButton);

});

parcelRegister("bv6rO", function(module, exports) {
$parcel$export(module.exports, "default", () => $e81ff9189b9a6692$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $gmMgo = parcelRequire("gmMgo");


var $aK2ZC = parcelRequire("aK2ZC");


var $4KS7f = parcelRequire("4KS7f");


var $f8J4a = parcelRequire("f8J4a");


var $3gadb = parcelRequire("3gadb");


var $6uN0A = parcelRequire("6uN0A");


var $gi5bC = parcelRequire("gi5bC");

const $e81ff9189b9a6692$var$CodeBlockWrapButton = ({ setWrapLongLines: setWrapLongLines, wrapLongLines: wrapLongLines, intl: intl })=>{
    const wrapMessage = intl.formatMessage(wrapLongLines ? (0, $f8J4a.codeBlockButtonMessages).unwrapCode : (0, $f8J4a.codeBlockButtonMessages).wrapCode);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6uN0A.default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
            content: wrapMessage,
            hideTooltipOnClick: false,
            position: "top"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4KS7f.default), {
            appearance: "subtle",
            "aria-haspopup": true,
            "aria-label": wrapMessage,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `wrap-code ${wrapLongLines ? 'clicked' : ''}`,
            iconBefore: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aK2ZC))), {
                label: ""
            }),
            isSelected: wrapLongLines,
            onClick: (event)=>{
                fireAnalyticsEvent({
                    // @ts-expect-error - Type 'ACTION.CLICKED' is not assignable to type 'ACTION.CLICKED | ACTION.MEDIA_LINK_TRANSFORMED | ACTION.STARTED | ACTION.TOGGLE_EXPAND | ACTION.UNSUPPORTED_CONTENT_ENCOUNTERED | ACTION.VISITED | ACTION.RENDERED | ACTION.INVALID_PROSEMIRROR_DOCUMENT | ACTION.CRASHED | ... 6 more ... | AnnotationActionType'
                    // This error was introduced after upgrading to TypeScript 5
                    action: (0, $gi5bC.ACTION).CLICKED,
                    actionSubject: (0, $gi5bC.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $gi5bC.ACTION_SUBJECT_ID).CODEBLOCK_WRAP,
                    attributes: {
                        wrapped: !wrapLongLines
                    },
                    eventType: (0, $gi5bC.EVENT_TYPE).UI
                });
                setWrapLongLines(!wrapLongLines);
                event.stopPropagation();
            },
            spacing: "compact"
        }))));
};
var $e81ff9189b9a6692$export$2e2bcd8739ae039 = (0, $gmMgo.default)($e81ff9189b9a6692$var$CodeBlockWrapButton);

});


//# sourceMappingURL=codeBlock.9d899c87.js.map
